/**
 * What a clicked feature is, for its popup's title: a key under `viewer:feature.titles` and its
 * values, from the layer it was hit in. Anything not named here is a plain "feature".
 */
import { HEALTH_FIELDS, HEALTH_HOTSPOTS, MLS_INVALID, TREE_FIELDS, type ObjectKind } from './layers';

export interface FeatureTitle {
  key: string;
  values?: Record<string, string>;
}

export function featureTitle(kind: ObjectKind | undefined, table: string | undefined, properties: Record<string, unknown>): FeatureTitle {
  const invalid = properties[TREE_FIELDS.genus] === MLS_INVALID;
  switch (kind) {
    case 'ortho_tree_analysis':
      return { key: 'orthoCrown' };
    case 'crown_health': {
      const hotspot = properties[HEALTH_FIELDS.hotspot];
      if (table === HEALTH_HOTSPOTS) return { key: 'hotspot', values: { number: hotspot === undefined || hotspot === null ? '' : String(hotspot) } };
      return { key: 'healthCrown' };
    }
    case 'mls_tree_analysis':
      if (invalid) return { key: 'mlsInvalid' };
      return { key: table === 'crown' ? 'mlsCrown' : 'mlsStem' };
    case 'forest_summary': {
      if (table === 'mls_area') return { key: 'mlsArea' };
      if (table === 'field_area') return { key: 'fieldArea' };
      const level = typeof properties.level === 'string' ? properties.level : '';
      const name = properties.name === undefined || properties.name === null ? '' : String(properties.name);
      return level ? { key: 'unit', values: { level, name } } : { key: 'feature' };
    }
    case 'field_annotations':
      return { key: table === 'area' ? 'fieldArea' : 'fieldTrunk' };
    case 'drone_photos_raw':
      return { key: 'photo' };
    case 'boundary':
      return { key: 'boundary' };
    default:
      return { key: 'feature' };
  }
}
